import { _ as _objectWithoutProperties, a as _extends, c as _defineProperty } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-pager-1-6-0{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;max-width:100%;padding-top:1px}.hcr-pager__item-1-6-0{display:block;min-width:44px;height:44px;margin-top:-1px;margin-left:-1px;border:1px solid #c8c8c8;color:#444;font-size:16px;font-weight:400;line-height:42px;text-align:center;text-decoration:none}.hcr-pager__item-1-6-0:active,.hcr-pager__item-1-6-0:focus{text-decoration:none}.hcr-pager__item-1-6-0:hover{background-color:#5cac00;color:#fff}@media (min-width:1200px){.hcr-pager__item-1-6-0{min-width:36px;height:36px;line-height:36px}}.hcr-pager__item-1-6-0:first-child{border-radius:5px 0 0 5px}.hcr-pager__item-1-6-0:last-child{border-right:1px solid #c8c8c8;border-radius:0 5px 5px 0}.hcr-pager__item--active-1-6-0{background-color:#73d700;color:#fff}.hcr-pager__item--disabled-1-6-0{cursor:not-allowed;opacity:.5}.hcr-pager__item--disabled-1-6-0:hover{background-color:transparent;color:#444}.hcr-pager__item--next-1-6-0,.hcr-pager__item--prev-1-6-0{font-size:0}.hcr-pager__item--next-1-6-0.hcr-pager__item--disabled-1-6-0:hover:after,.hcr-pager__item--next-1-6-0:after,.hcr-pager__item--prev-1-6-0.hcr-pager__item--disabled-1-6-0:hover:after,.hcr-pager__item--prev-1-6-0:after{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M636.4 236.4a28.2 28.2 0 010 40.4L417.7 493.2a8.2 8.2 0 000 13.6l218.7 216.4a28.6 28.6 0 01-40.5 40.4L377.3 545.5a66.4 66.4 0 01-19.6-45.5 66.4 66.4 0 0119.6-45.5l216.3-218.1a28.2 28.2 0 0142.8 0z' fill='rgba(68, 68, 68, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-pager__item--next-1-6-0:hover:after,.hcr-pager__item--prev-1-6-0:hover:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M636.4 236.4a28.2 28.2 0 010 40.4L417.7 493.2a8.2 8.2 0 000 13.6l218.7 216.4a28.6 28.6 0 01-40.5 40.4L377.3 545.5a66.4 66.4 0 01-19.6-45.5 66.4 66.4 0 0119.6-45.5l216.3-218.1a28.2 28.2 0 0142.8 0z' fill='rgba(255, 255, 255, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-pager__item--next-1-6-0.hcr-pager__item--disabled-1-6-0:hover:after,.hcr-pager__item--next-1-6-0:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M365.9 763.6a28.2 28.2 0 010-40.4l216.4-216.4a8.2 8.2 0 000-13.6L365.9 276.8a28.6 28.6 0 0140.5-40.4l216.3 218.1a66.4 66.4 0 0119.6 45.5 66.4 66.4 0 01-19.6 45.5L406.4 763.6a28.2 28.2 0 01-40.5 0z' fill='rgba(68, 68, 68, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-pager__item--next-1-6-0:hover:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M365.9 763.6a28.2 28.2 0 010-40.4l216.4-216.4a8.2 8.2 0 000-13.6L365.9 276.8a28.6 28.6 0 0140.5-40.4l216.3 218.1a66.4 66.4 0 0119.6 45.5 66.4 66.4 0 01-19.6 45.5L406.4 763.6a28.2 28.2 0 01-40.5 0z' fill='rgba(255, 255, 255, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}",
map:{"hcr-pager":"hcr-pager-1-6-0","hcr-pager__item":"hcr-pager__item-1-6-0","hcr-pager__item--active":"hcr-pager__item--active-1-6-0","hcr-pager__item--disabled":"hcr-pager__item--disabled-1-6-0","hcr-pager__item--prev":"hcr-pager__item--prev-1-6-0","hcr-pager__item--next":"hcr-pager__item--next-1-6-0"}};

var PagerArrowButton = function PagerArrowButton(_ref) {
  var _bem$e;

  var side = _ref.side,
      disabled = _ref.disabled,
      active = _ref.active,
      Elem = _ref.Elem,
      bem = _ref.bem,
      rest = _objectWithoutProperties(_ref, ["side", "disabled", "active", "Elem", "bem"]);

  return React.createElement(Elem, _extends({
    className: bem.e('item', (_bem$e = {}, _defineProperty(_bem$e, side, true), _defineProperty(_bem$e, "disabled", disabled), _defineProperty(_bem$e, "active", active), _bem$e))
  }, rest));
};
PagerArrowButton.defaultProps = {
  disabled: false,
  active: false
};
PagerArrowButton.propTypes = {
  bem: PropTypes.object.isRequired,
  // eslint-disable-line
  side: PropTypes.string.isRequired,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  Elem: PropTypes.string.isRequired
};

var bem = Bem('pager', styles);
var Pager = function Pager(_ref) {
  var items = _ref.items,
      Elem = _ref.Elem,
      prevButton = _ref.prevButton,
      nextButton = _ref.nextButton,
      extraClasses = _ref.extraClasses;
  return React.createElement("div", {
    className: bem.b(false, extraClasses)
  }, prevButton && React.createElement(PagerArrowButton, _extends({
    bem: bem,
    side: "prev",
    Elem: Elem
  }, prevButton)), items.map(function (_ref2) {
    var text = _ref2.text,
        disabled = _ref2.disabled,
        active = _ref2.active,
        rest = _objectWithoutProperties(_ref2, ["text", "disabled", "active"]);

    return React.createElement(Elem, _extends({
      key: text,
      className: bem.e('item', {
        disabled: disabled,
        active: active
      })
    }, rest), text);
  }), nextButton && React.createElement(PagerArrowButton, _extends({
    bem: bem,
    side: "next",
    Elem: Elem
  }, nextButton)));
};
Pager.displayName = 'Pager';
Pager.defaultProps = {
  Elem: 'a',
  prevButton: false,
  extraClasses: '',
  nextButton: false
};
Pager.propTypes = {
  /** Items to be represented as pagers */
  items: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired
  })).isRequired,

  /**
    Toggles the prev button, optinally pass an object which will be spread on the button itself
    Use this to attach any event you need to the button
   */
  prevButton: PropTypes.oneOfType([PropTypes.object, // eslint-disable-line
  PropTypes.bool]),

  /**
    Toggles the next button, optinally pass an object which will be spread on the button itself
    Use this to attach any event you need to the button
   */
  nextButton: PropTypes.oneOfType([PropTypes.object, // eslint-disable-line
  PropTypes.bool]),

  /** Override default element for pager items (<a>) */
  Elem: PropTypes.string,

  /** Injection in className */
  extraClasses: PropTypes.string
};
var pager = Injecss(Pager, styles);

export { pager as Pager };
